import type IScoreboardMunicipality from '../../../models/pa-egna-ben/scoreboard-municipality.model';

export default class ScoreboardMunicipalityApiModel {
  public gid!: string;
  public name!: string;
  public numberOfParticipations!: number;

  public static mapToBusinessModel(apiModel: ScoreboardMunicipalityApiModel): IScoreboardMunicipality {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      numberOfParticipations: apiModel.numberOfParticipations,
    };
  }
}
